import { Component } from 'react';
// React-DML imports
import { Cell, Grid } from 'react-mdl';

export class Landing extends Component {
  render() {
    return (
      <div>
        <Grid className='HomePageGrid'>
          <Cell col={12}>
            {/* Hero Section */}
            <div
              className='Profile-title-text'
              style={{ textAlign: 'center', padding: '40px 20px' }}
            >
              <img
                src='./images/rakeen-logo.png'
                alt='Rakeen Technology Logo'
                style={{
                  width: '160px',
                  height: '160px',
                  marginBottom: '15px',
                }}
              />

              <h1 style={{ fontSize: '48px' }}>Rakeen</h1>
              <h2
                style={{
                  fontSize: '22px',
                  fontWeight: '400',
                  color: 'var(--text-muted)',
                  marginTop: '8px',
                }}
              >
                Digital Marketing & CRM Solutions
              </h2>

              <p
                style={{
                  maxWidth: '650px',
                  margin: '20px auto 0',
                  fontSize: '1.1em',
                  lineHeight: '1.6',
                  color: 'var(--text-muted)',
                }}
              >
                Rakeen is a technology company based in Riyadh, Saudi Arabia. We
                build marketing and business management tools that help
                companies manage their advertising campaigns, track leads, and
                grow their sales — all from a single platform.
              </p>
              <p
                style={{
                  maxWidth: '650px',
                  margin: '12px auto 0',
                  fontSize: '1em',
                  lineHeight: '1.5',
                  color: 'var(--text-subtle)',
                }}
              >
                Originally established in collaboration with{' '}
                <a
                  href='https://al-yem.com'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Al-Yem
                </a>{' '}
                to lead the digital transformation of real estate operations,
                Rakeen now provides marketing technology and CRM solutions for
                businesses across multiple industries.
              </p>
              <a
                href='/contact'
                className='demo-button'
              >
                Contact Us
              </a>
            </div>

            {/* What We Build Section */}
            <div
              style={{
                maxWidth: '900px',
                margin: '40px auto',
                padding: '0 20px',
              }}
            >
              <h2
                style={{
                  textAlign: 'center',
                  color: 'var(--text-heading)',
                  marginBottom: '30px',
                }}
              >
                What We Build
              </h2>
              <div className='features-grid'>
                <div className='feature-card'>
                  <h3>Campaign Management</h3>
                  <p>
                    Manage advertising campaigns across TikTok, Snapchat, and
                    other platforms from one unified dashboard. Create
                    campaigns, control budgets, toggle statuses, and manage ad
                    groups and ads with full targeting options.
                  </p>
                </div>
                <div className='feature-card'>
                  <h3>CRM & Sales</h3>
                  <p>
                    Full customer relationship management with contact tracking,
                    deal pipelines, task management, and team coordination tools
                    to streamline your sales process.
                  </p>
                </div>
                <div className='feature-card'>
                  <h3>Analytics & Reporting</h3>
                  <p>
                    Real-time performance metrics, KPI benchmarks, health
                    scoring, and flexible reporting with CSV export. Monitor
                    CTR, CPM, CPC, conversion rates, and more.
                  </p>
                </div>
                <div className='feature-card'>
                  <h3>Landing Pages & Attribution</h3>
                  <p>
                    Build ad landing pages with built-in UTM tracking, visitor
                    analytics, conversion funnels, and lead attribution to
                    measure the full marketing pipeline.
                  </p>
                </div>
              </div>
            </div>

            {/* Platform Integrations Section */}
            <div
              style={{
                maxWidth: '900px',
                margin: '40px auto',
                padding: '30px 20px',
                textAlign: 'center',
              }}
            >
              <h2
                style={{ color: 'var(--text-heading)', marginBottom: '12px' }}
              >
                Platform Integrations
              </h2>
              <p
                style={{
                  color: 'var(--text-subtle)',
                  maxWidth: '600px',
                  margin: '0 auto 24px',
                  lineHeight: '1.5',
                }}
              >
                Our platform integrates directly with major advertising APIs,
                enabling businesses to manage their ad accounts securely through
                OAuth-based authentication.
              </p>
              <div className='integrations-list'>
                <div className='integration-item'>
                  <strong>TikTok for Business</strong>
                  <span>
                    Campaign management, ad groups, ads, media upload, reporting
                  </span>
                </div>
                <div className='integration-item'>
                  <strong>Snapchat Marketing API</strong>
                  <span>
                    Campaign analytics, ad management, audience targeting,
                    diagnostics
                  </span>
                </div>
              </div>
            </div>

            {/* Company Info Section */}
            <div
              style={{
                maxWidth: '700px',
                margin: '30px auto 40px',
                padding: '24px',
                textAlign: 'center',
                backgroundColor: 'var(--bg-card-alt)',
                borderRadius: '10px',
              }}
            >
              <h3
                style={{ color: 'var(--text-heading)', marginBottom: '12px' }}
              >
                About Rakeen
              </h3>
              <p
                style={{
                  color: 'var(--text-muted)',
                  lineHeight: '1.6',
                  margin: '0',
                }}
              >
                Rakeen is headquartered in Khobar, Saudi Arabia. We specialize
                in building SaaS tools for digital marketing and business
                operations. Our platform serves real estate developers,
                e-commerce businesses, and service providers who need to manage
                advertising campaigns, track customer relationships, and analyze
                marketing performance from a single dashboard. It is registered
                under the name Durrat Rakeen for Business Solutions, and is
                licensed to operate in Saudi Arabia with commercial registration
                number
                <a
                  href='https://mc.gov.sa/en/eservices/Pages/Commercial-data.aspx'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <strong>
                    <u> 7051429145</u>
                  </strong>
                </a>
                .
              </p>
            </div>
          </Cell>
        </Grid>
      </div>
    );
  }
}

export default Landing;
